module.exports = __webpack_public_path__ + "static/assets/03411ae5b84f2c6f0deef0047828b91d.gif";